import "./styles.css"
import { ReactComponent as PlusIcon } from "../../../assets/svg/icons/plus.svg";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import TableVisualizationRow from "./TableVisualizationRow/Index";
import { Loading } from "../../Loading/Index";

interface TableProductsProps {
  listTable: IProducts[];
  isLoading: boolean;
}

export default function TableProducts({ listTable, isLoading }: TableProductsProps) {

  const {
    setOptionForm,
  } = useEditOnboarding();

  return (
    <>
      {listTable && listTable.length > 0 ?
        <>
          <section className="tableColumn">
            <div>Classificação</div>
            <div>Nome comercial</div>
            <div>Fabricante</div>
            <div />
          </section>

          <section
            className="tableViewRows"
            style={{
              position: "relative",
            }}
          >
            <Loading visible={isLoading} />
            {listTable.map(product =>
              <TableVisualizationRow product={product} />
            )}
          </section>
        </>
        :
        isLoading
          ?
          <div className="emptyTable_container">
            <Loading visible={isLoading} />
          </div>
          :
          <div className="emptyTable_container">
            <span>cadastre seu primeiro produto</span>
            <div
              className="addProduct_button"
              onClick={() => {
                setOptionForm("create-products")
              }}
            >
              <PlusIcon />
              <span>cadastrar produto</span>
            </div>
          </div>
      }
    </>
  )
}